import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../commonComponents/modal/Modal';
import ModalHeader from '../../../../commonComponents/modal/ModalHeader';
import ModalFooter from '../../../../commonComponents/modal/ModalFooter';
import translate from '../../../../commonComponents/translate';
import GameProp from '../../propTypes/gameProp';
import FormInput from '../../../../commonComponents/forms/FormInput';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import { findCurrencySymbol } from '../../../../services/utilityFunctions';

function ConfirmScoreModal({ t, onClose, challenge, currencies }) {
  const { isCustomScore: customScore, scoreApproved, unity, currency } = challenge.challenges;
  const [score, setScore] = useState();
  const isCustomScore = customScore || false;
  let currencySymbol = '€';
  if (currency) {
    currencySymbol = findCurrencySymbol(currency, currencies);
  }
  let unityToUse = unity !== 'currency' ? t(`challengeDetails_leaderboard_${unity}`) : currencySymbol;
  if (unity === 'percentage') {
    unityToUse = '%';
  }

  return (
    <Modal id="scoreModal" onClose={() => onClose(false)} tabIndex={null}>
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <ModalHeader
            title={t('challengeDetails_scoreConfirmation')}
            onClose={() => onClose(false)}
          />
          <div
            id="modalBody"
            className="modal-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            {!isCustomScore ? (
              <p>{t('challengeDetails_scoreMessage', scoreApproved, unityToUse)}</p>
            ) : (
              <div className="customScore">
                <p>{t('challengeDetails_customMessage')}</p>
                <div className="label-score">{t('challengeDetails_score')}</div>
                <FormInput
                  id="scoreInput"
                  value={score}
                  name="scoreInput"
                  placeholder={t('challengeDetails_insertScore')}
                  type="gameScore"
                  inputProps={{
                    min: 0,
                  }}
                  unity={unityToUse}
                  onChange={valueScore => setScore(valueScore)}
                />
              </div>
            )}
          </div>
          <ModalFooter
            onCancel={() => onClose(false)}
            onSave={() => onClose(true, isCustomScore, score)}
            cancelText={t('cancel')}
            saveText={t('confirm')}
          />
        </div>
      </div>
    </Modal>
  );
}

ConfirmScoreModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)).isRequired,
};

export default translate(ConfirmScoreModal);
